import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle';
// 课程退款订单列表
export const courseRefundOrderList = [
  key(null, null, tableColumnsWidth.type1, {
    type: 'selection',
    fixed: 'left'
  }),
  key('退款单号', 'insOrderId', 190, { fixed: 'left' }),
  key('订单号', 'relOrderId', 190, { fixed: 'left' }),
  key('姓名', 'studentName', tableColumnsWidth.type2, { fixed: 'left' }),
  key('年级班级', 'gradeClassName', tableColumnsWidth.type8, { fixed: 'left' }),
  slot('学校', 'schoolName', tableColumnsWidth.type6),
  key('退款类型', 'refundType', tableColumnsWidth.type4),
  slot('商品名称', 'offerName', tableColumnsWidth.type6),
  key('学期', 'yearTerm', 190),
  slot('提供方', 'orgName', tableColumnsWidth.type6), // 新增的
  slot('上课时间', 'classTimeDesc', tableColumnsWidth.type7),
  key('申请金额（元）', 'ordFee', tableColumnsWidth.type2, {
    align: 'center',
    renderHeader: (h, params) => {
      return h(
        'Tooltip',
        { props: { placement: 'top', transfer: true, 'max-width': '300' }}, // 提示组件的属性
        [
          h('span', [
            h('span', '申请金额（元）'), // 列名
            h('Icon', { props: { type: 'ios-alert-outline' }}) // 问号图标
          ]),
          h(
            'span',
            {
              slot: 'content'
            },
            '申请金额以申请时的考勤节次费用之和为准，如果审批时，对节次进行的修改，则不改变原有的申请金额'
          ) // 提示内容
        ]
      );
    }
  }),
  slot('实退金额（元）', 'chargeFee', tableColumnsWidth.type2, {
    align: 'center'
  }),
  slot('实际退款课时数', 'courseRefundCount', tableColumnsWidth.type2, {
    align: 'center'
  }),
  slot('材料费实际退款课时数', 'materialRefundCount', tableColumnsWidth.type9, {
    align: 'center'
  }),
  key('收款方式', 'payTypeText', tableColumnsWidth.type2, {
    align: 'center'
  }),
  slot('退款申请渠道', 'refundReqType', tableColumnsWidth.type3),
  // slot('审批状态', 'approveSts', tableColumnsWidth.type3),
  // slot('退款状态', 'paySts', tableColumnsWidth.type3),
  slot('审批状态', 'refundCheckSts', tableColumnsWidth.type9, {
    align: 'center'
  }),
  slot('退款状态', 'refundSts', tableColumnsWidth.type9, {
    align: 'center'
  }),
  slot('退款周期方式', 'refundCycleMethod', tableColumnsWidth.type8, {
    align: 'center'
  }),
  key('退款批次ID', 'batchRefundId', 190, {
    align: 'center'
  }),
  slot('创建时间', 'createTime', tableColumnsWidth.type4),
  key('处理时间', 'reviewTime', tableColumnsWidth.type4),
  key('退款完成时间', 'refundOperateTime', tableColumnsWidth.type4),
  slot('操作', 'action', tableColumnsWidth.type5, {
    fixed: 'right'
  })
];
